import React from "react";
import { Link } from "react-router-dom";

const ProductInfo = ({ productInfo }) => {
  const description = productInfo?.des ? String(productInfo.des) : "";

  return (
    <div className="flex flex-col gap-5">
      
      {/* SEO-Friendly Product Title */}
      <h1 className="text-4xl font-semibold leading-snug text-primeColor">
        {productInfo.productName}
      </h1>

      {/* Product Size */}
      {productInfo.size && (
        <p className="font-normal">
          <span className="font-semibold">Size: </span>
          {productInfo.size}
        </p>
      )}

      {/* Product Color */}
      {productInfo.color && (
        <p className="font-normal">
          <span className="font-semibold">Color: </span>
          {productInfo.color}
        </p>
      )}

      {/* Weight */}
      {productInfo.Weight && (
        <p className="font-normal">
          <span className="font-semibold">Weight: </span>
          {productInfo.Weight}
        </p>
      )}

      {/* Taste */}
      {productInfo.Taste && (
        <p className="font-normal">
          <span className="font-semibold">Taste: </span>
          {productInfo.Taste}
        </p>
      )}

      {/* Varieties */}
      {productInfo.Varities && (
        <p className="font-normal">
          <span className="font-semibold">Varieties: </span>
          {productInfo.Varities}
        </p>
      )}

      {/* Packaging */}
      {productInfo.packaging && (
        <p className="text-base">
          <span className="font-semibold">Packaging: </span>
          {productInfo.packaging}
        </p>
      )}

      {/* SEO Optimized Description */}
      <h2 className="font-semibold text-xl mt-2">Product Description</h2>
      <div className="text-base text-gray-700 leading-relaxed text-justify">
        {description.split("\n").map((line, index) => (
          <p key={index} className="mb-2">
            {line}
          </p>
        ))}
      </div>

      {/* CTA Button - SEO Friendly */}
      <Link to="/enquirenow">
        <button className="w-full py-4 bg-primeColor hover:bg-black duration-300 text-white text-lg font-titleFont rounded-md">
          Enquire Now
        </button>
      </Link>

      {/* Product Specifications Block */}
      <div className="mt-4">
        {productInfo?.speci &&
          productInfo.speci.map((spec) => (
            <div
              key={spec._id}
              className="border rounded-md p-4 shadow-sm mb-4 bg-white"
            >
              <h3 className="font-semibold text-lg mb-3">
                {productInfo.productName} Detailed Specifications
              </h3>

              {/* Specification Grid */}
              <div className="grid grid-cols-2 gap-y-2 text-sm text-gray-700">
                <span>{spec._pur}</span>
                <span>: {spec.Purity}</span>

                <span>{spec._Natural}</span>
                <span>: {spec.Natural_Adm}</span>

                <span>{spec._avg}</span>
                <span>: {spec.AverageGrain}</span>

                <span>{spec._Moisture}</span>
                <span>: {spec.Moisture}</span>

                <span>{spec._BrokenGrain}</span>
                <span>: {spec.BrokenGrain}</span>

                <span>{spec._DamageGrain}</span>
                <span>: {spec.DamageGrain}</span>

                <span>{spec._ImmatureGrain}</span>
                <span>: {spec.ImmatureGrain}</span>

                <span>{spec._ForeignMatter}</span>
                <span>: {spec.ForeignMatter}</span>

                <span>{spec._PackagingType}</span>
                <span>: {spec.PackagingType}</span>

                <span>{spec._SupplyAbility}</span>
                <span>: {spec.SupplyAbility}</span>

                <span>{spec._MainExportMarket}</span>
                <span>: {spec.MainExportMarket}</span>

                <span>{spec._DeliveryTime}</span>
                <span>: {spec.DeliveryTime}</span>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ProductInfo;
